import { render, staticRenderFns } from "./NewComments.vue?vue&type=template&id=736b9ead&scoped=true"
import script from "./NewComments.vue?vue&type=script&lang=js"
export * from "./NewComments.vue?vue&type=script&lang=js"
import style0 from "./NewComments.vue?vue&type=style&index=0&id=736b9ead&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736b9ead",
  null
  
)

export default component.exports